define([
  "knockout",
  "jquery",
  "helpers",
  "globals",
  "text!dictionary-template",
  "dictionary-binding"
  ],
function(ko, $, helpers, globals, template) {
  "use strict";

  ko.components.register("dictionary", {
    template: template
  });
});
